import { EShipping } from '@/src/types/common/discount';
import { get } from 'lodash';
import React from 'react';
import {
  Form,
  OriNumberInput,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { isNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { last2Precision } from 'src/tools/regExp';
import css from './css.module.less';

const Item = Form.Item;
const radioName = ['voucherMethod', 'shippingDiscountType'];
const inputName = ['voucherMethod', 'fixedAmount'];

const ShippingDiscount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency, disabled } = props;
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={getI18n('voucher.storeVoucherDetail.voucherValue')}>
      <Item
        name={radioName}
        rules={[{ required: true, message: 'Please select a value' }]}>
        <RadioGroup className={css.radioGroup} disabled={disabled}>
          <RadioItem className={css.radio} value={EShipping.Free}>
            {getI18n('voucher.storeVoucherDetail.freeShipping')}
          </RadioItem>
          <RadioItem value={EShipping.Fixed}>
            {getI18n('voucher.storeVoucherList_config.fixedReductionAmount')}
          </RadioItem>
        </RadioGroup>
      </Item>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, radioName);
          const cV = get(c, radioName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const checked = getFieldValue(radioName) === EShipping.Fixed;
          if (checked) {
            return (
              <div className={css.maxContainer}>
                <Item
                  className={css.maxAmount}
                  name={inputName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if (!isNumber(value)) {
                          return Promise.reject(
                            new Error(getI18n('general.pleasefillthisfield')),
                          );
                        }
                        if (value < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                              ),
                            ),
                          );
                        }
                        if (!last2Precision.test(value)) {
                          return Promise.reject(
                            new Error(getI18n('general.twoDecimal')),
                          );
                        }
                      },
                    },
                  ]}>
                  <OriNumberInput
                    size='large'
                    suffix={currency}
                    disabled={disabled}
                  />
                </Item>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </SectionWrapper>
  );
};
export default ShippingDiscount;
